// extracted by mini-css-extract-plugin
export default {"ensemblMark":"ensemblMark__EnsemblMarkIcon__5ZbXf"};